// Custom calculation functions for DDR
import { apiFetch, getLatestDDRData } from '../api/api';

/**
 * Compute cumulative cost: previous cumulative + current daily cost
 */
export async function computeCumulativeCost({ selectedWellId, reportDate, sectionEditingData }) {
  // Debug inputs for cumulative cost
  console.log('[DEBUG] computeCumulativeCost called with:', { selectedWellId, reportDate, sectionEditingData });
  // Fetch last DDR data for DailyWellData
  const response = await getLatestDDRData(selectedWellId, 'DailyWellData', reportDate);
  const lastRecord = Array.isArray(response.data) && response.data.length > 0
    ? response.data[0]
    : null;
  const lastCumul = lastRecord && lastRecord.CumulativeCost
    ? parseFloat(lastRecord.CumulativeCost) || 0
    : 0;
  // Debug raw daily cost value
  console.log('[DEBUG] DailyCost raw value:', sectionEditingData.DailyCost);
  const currentDaily = sectionEditingData.DailyCost != null
    ? (parseFloat(sectionEditingData.DailyCost) || 0)
    : 0;
  // Debug parsed values
  console.log('[DEBUG] lastCumul:', lastCumul, 'currentDaily:', currentDaily);
  const newCumul = lastCumul + currentDaily;
  return Math.round(newCumul * 100) / 100;
}

/**
 * Compute NPT Hours: sum DurationHours from DailyActivity table where JobCode === 'NPT'
 */
export async function computeNptHours({ currentReportId }) {
  // Fetch current DailyActivity records
  const tableData = await apiFetch(`/api/db/DailyActivity?filter=ReportID,eq,${currentReportId}`);
  const sum = Array.isArray(tableData)
    ? tableData.reduce((acc, row) => {
        if (row.JobCode === 'NPT' && row.DurationHours != null) {
          return acc + (parseFloat(row.DurationHours) || 0);
        }
        return acc;
      }, 0)
    : 0;
  return Math.round(sum * 100) / 100;
}

/**
 * Registry of custom calculations keyed by name
 */
export const customCalculations = {
  computeCumulativeCost,
  computeNptHours
}; 